import { createFileRoute } from '@tanstack/react-router';
import { QuickLinksPage } from '@/pages/chain/QuickLinksPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function ChainQuickLinksPage() {
	return <QuickLinksPage />;
}

export const Route = createFileRoute('/_authenticated/_app/chain/quick-links')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['chainConfig.manageQuickLinks', 'chainConfig.manageConfigPushes', 'chainConfig.manageBranding'],
			redirectTo: '/dashboard',
		}),
	component: ChainQuickLinksPage,
});
